import APIError from '@api/exceptions/APIError';
import { PROXY_ERRORS } from '@constants';

const ERRORS = {
	400: PROXY_ERRORS.BAD_REQUEST,
	403: PROXY_ERRORS.FORBIDDEN,
	413: PROXY_ERRORS.PAYLOAD_TOO_LARGE,
	429: PROXY_ERRORS.RATE_LIMITED,
	500: PROXY_ERRORS.INTERNAL_SERVER_ERROR,
	502: PROXY_ERRORS.BAD_GATEWAY,
	504: PROXY_ERRORS.GATEWAY_TIMEOUT,
	508: PROXY_ERRORS.TOO_MANY_REDIRECTS,
};

class ProxyError extends APIError {
	constructor(message, code = 500, isBotProtection = false) {
		super(message, code);

		this.name = 'ProxyError';
		this.code = code;
		
		// If it's bot protection, use the specific error code
		if (isBotProtection && code === 403) {
			this.proxyErrorCode = PROXY_ERRORS.BOT_PROTECTION;
		} else {
			this.proxyErrorCode = ERRORS[code] || PROXY_ERRORS.INTERNAL_SERVER_ERROR;
		}
	}
}

export default ProxyError;
